import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const projectService = {
    getAllProjects: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/projects`);
            return response.data;
        } catch (error) {
            console.error('Error fetching projects:', error);
            throw error;
        }
    },

    getProjectById: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/projects/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching project:', error);
            throw error;
        }
    }
}; 